export const menuPlacement = (x, bottomThreshold, defaultPlacement) => {
    const row = document.getElementById(`Row-${x}`);
    if (row) {
        var rect = row.getBoundingClientRect();
        const bottomPoition = window.innerHeight - rect.bottom;
        if (bottomPoition < bottomThreshold)
            return 'top';
    }
    return defaultPlacement;
}

export const menuPlacementR1 = (x, upThreshold, defaultPlacement) => {
    const row = document.getElementById(`Row-${x}`);
    const header=document.getElementById(`header-row`);
    if (row) {
        var rowRect = row.getBoundingClientRect();
        var headerRect = header.getBoundingClientRect();
        if (rowRect.top-upThreshold > headerRect.bottom)
            return 'top';
    }
    return defaultPlacement;
}


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/selectHelper.js